import { cn } from '@/lib/utils';
import * as React from 'react';
import type { SVGProps } from 'react';

const SvgClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className={cn('h-6 w-6', props.className)}
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>

  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width="20"
  //   height="20"
  //   viewBox="0 0 20 20"
  //   fill="none"
  //   {...props}
  // >
  //   <path
  //     fillRule="evenodd"
  //     clipRule="evenodd"
  //     d="M5.83328 3.76398C7.06665 2.93987 8.5167 2.5 10.0001 2.5C11.9885 2.50235 13.8948 3.29328 15.3008 4.69929C16.7068 6.1053 17.4977 8.0116 17.5001 10C17.5001 11.4834 17.0602 12.9334 16.2361 14.1668C15.412 15.4001 14.2406 16.3614 12.8702 16.9291C11.4997 17.4968 9.99174 17.6453 8.53688 17.3559C7.08203 17.0665 5.74565 16.3522 4.69676 15.3033C3.64787 14.2544 2.93356 12.918 2.64417 11.4632C2.35478 10.0083 2.50331 8.50032 3.07096 7.12987C3.63862 5.75943 4.59992 4.58809 5.83328 3.76398ZM6.59088 15.1022C7.6 15.7765 8.7864 16.1364 10.0001 16.1364C11.6269 16.1344 13.1866 15.4872 14.3369 14.3369C15.4873 13.1865 16.1344 11.6269 16.1364 10C16.1364 8.78634 15.7765 7.59994 15.1023 6.59082C14.428 5.5817 13.4696 4.79519 12.3483 4.33074C11.2271 3.86629 9.99325 3.74477 8.80292 3.98154C7.61258 4.21832 6.51918 4.80275 5.661 5.66093C4.80281 6.51912 4.21838 7.61252 3.98161 8.80285C3.74483 9.99319 3.86635 11.227 4.3308 12.3483C4.79525 13.4696 5.58176 14.4279 6.59088 15.1022ZM10.6817 5.90909V9.71773L12.5274 11.5634C12.6516 11.692 12.7203 11.8642 12.7188 12.043C12.7172 12.2218 12.6455 12.3928 12.5191 12.5192C12.3927 12.6456 12.2217 12.7173 12.0429 12.7189C11.8641 12.7204 11.6919 12.6517 11.5633 12.5275L9.51785 10.482C9.38998 10.3542 9.31812 10.1808 9.31808 10V5.90909C9.31808 5.72826 9.38991 5.55484 9.51778 5.42697C9.64564 5.29911 9.81907 5.22727 9.9999 5.22727C10.1807 5.22727 10.3541 5.29911 10.482 5.42697C10.6099 5.55484 10.6817 5.72826 10.6817 5.90909Z"
  //     fill="#A5A5AA"
  //   />
  // </svg>
);
export default SvgClock;
